import { moveModal } from "../../../../utils/Utils";
import { useEffect, useState } from "react";
import ModalTimeTable from "./ModalTimeTable";
import proxy from "../../../../utils/Proxy";
import Days from "../../../../utils/constants/Days";
import TeacherSelector from "../../../../elements/selector/TeacherSelector";
import LocationCode from "../../../../utils/constants/LocationCode";

let TableRegisterModal = (props) => {
    let teachers = props.data.teachers;
    let [currentTeacher, setCurrentTeacher] = useState(Object.keys(teachers)[0])
    let [dailyTable, setDailyTable] = useState(null)

    let [needUpdate, setNeedUpdate] = useState(false)

    let fetchTables = () => {
        proxy.get("/api/tables").then(res => {
            let data = res.data.data;
            setDailyTable(data);
            setNeedUpdate(false)
        }).catch(err => {
            console.log(err.response.data.message)
        })
    }
    useEffect(() => {
        setDailyTable(null)
        fetchTables()
    }, [needUpdate, currentTeacher])

    let save = () => {
        let dialogResult = window.confirm("저장 하시겠습니까?");
        if (dialogResult) {
            let currentTable = {}
            for (let day of Days.keyset) {
                currentTable[day] = [];
            }
            let elements = document.querySelectorAll("[class*='register-table-cell-selected']");
            if (elements.length !== 0)
                for (let e of elements) {
                    let id = e.id;
                    let idSplit = id.split(":");
                    let dayKey = idSplit[1];
                    let time = parseInt(idSplit[2]);
                    if (currentTable[dayKey].indexOf(time) === -1) {
                        currentTable[dayKey].push(time);
                    }
                }
            let body = {
                teacherid: parseInt(currentTeacher),
                times: currentTable
            }

            proxy.post("/adminapi/tables", body).then(_ => {
                window.alert("시간표가 저장되었습니다.");
                setNeedUpdate(true);
            }).catch(err => {
                window.alert(err.response.data.message);
                setNeedUpdate(true)
            })
        }
    }
    let cancelRegister = () => {
        let dialogResult = window.confirm("취소 하시겠습니까?")
        if (dialogResult) {
            props.setClosed();
        }
    }
    return <div className="modal-container">
        <div className="modal" id="teacher-details-modal">
            <div className="modal-content-container">
                <div className="modal-header" onMouseDown={e => moveModal(e, "teacher-details-modal")}>
                    <p className="modal-title">
                        강사 시간표 관리
                    </p>
                    <div className="modal-close-button" onClick={() => props.setClosed()}>
                    </div>
                </div>

                <div className="modal-content">
                    <div className="teacher-selector-wrapper">
                        <TeacherSelector data={props.data} currentTeacher={currentTeacher}
                            onTeacherChange={setCurrentTeacher.bind(this)} short={false}
                            location={LocationCode.ALL} containsAll={false}
                        />
                    </div>
                    {dailyTable !== null ?
                        <ModalTimeTable currentTeacher={currentTeacher} dailyTable={dailyTable} needUpdate={needUpdate}
                            setNeedUpdate={setNeedUpdate.bind(this)} /> : null}
                </div>
                <div className="modal-footer">
                    <div className="modal-footer-button-container">
                        <div className="modal-button" onClick={save}>
                            <p>저장</p>
                        </div>
                        <div className="modal-button" onClick={cancelRegister}>
                            <p>취소</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
export default TableRegisterModal;